import * as Sentry from "@sentry/vue";
import axios from 'axios';

import {
  API_URL, COMMUNITY_CREATE, COMMUNITY_DETAIL_REQUEST, COMMUNITY_EDIT,
  COMMUNITY_ERROR,
  COMMUNITY_REQUEST,
  COMMUNITY_SUCCESS,
  COMMUNITY_TYPE_REQUEST,
  SET_COMMUNITIES, SET_COMMUNITY_DETAIL,
  SET_COMMUNITY_TYPES,
  SET_NOTIFICATION,
  SET_TAGS,
  TAG_REQUEST, UPDATE_PICTURE
} from "@/store/constant";

const state = { communities: null, status: null, types: [], tags: [], communityDetail: null, approvedCommunityList: null, };

const getters = {
  communities: state => state.communities,
  communityTypes: state => state.types,
  communityStatus: state => state.status,
  tags: state => state.tags,
  community: state => state.communityDetail,
  approvedCommunityList: state => state.approvedCommunityList,
};

const actions = {
  [COMMUNITY_REQUEST]: ({commit}) => {
    commit(COMMUNITY_REQUEST);
    commit(SET_COMMUNITIES, null);
    return axios({ url: `${API_URL}/communities` })
      .then(resp => {
        commit(COMMUNITY_SUCCESS);
        commit(SET_COMMUNITIES, resp.data);
      })
      .catch(err => {
        commit(COMMUNITY_ERROR);
        commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages });
        Sentry.captureException(err);
      });
  },
  [COMMUNITY_TYPE_REQUEST]: ({commit}) => {
    axios({ url: `${API_URL}/types` })
      .then(resp => {
        commit(SET_COMMUNITY_TYPES, resp.data);
      })
      .catch(err => {
        commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages });
        Sentry.captureException(err);
      });
  },
  [TAG_REQUEST]: ({commit}) => {
    axios({ url: `${API_URL}/tags?_sort=title:ASC` })
      .then(resp => {
        commit(SET_TAGS, resp.data);
      })
      .catch(err => {
        commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages });
        Sentry.captureException(err);
      });
  },
  [COMMUNITY_CREATE]: ({ commit }, data) => {
    commit(COMMUNITY_REQUEST);
    return new Promise((resolve, reject) => {
      axios.post(`${API_URL}/communities`, data)
        .then(resp => {
          commit(COMMUNITY_SUCCESS);
          commit(SET_NOTIFICATION,{ type: 'info', messages: ['コミュニティが作成されました。'] });
          resolve(resp)
        })
        .catch(err => {
          commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages || [err.response.data.message] });
          commit (COMMUNITY_ERROR);
          reject(err);
          Sentry.captureException(err);
        });
    });
  },
  [COMMUNITY_DETAIL_REQUEST]: ({commit}, id) => {
    commit(COMMUNITY_REQUEST);
    commit(SET_COMMUNITY_DETAIL, null);
    axios({ url: `${API_URL}/communities/${id}` })
      .then(resp => {
        if (resp.data.status === 'pending_approval') {
          commit(SET_NOTIFICATION,{ type: 'info', messages: ['只今コミュニティが審査中です。完了しましたらメールでお知らせしますので、しばらくお待ち下さい。'] });
        }
        commit(COMMUNITY_SUCCESS);
        commit(SET_COMMUNITY_DETAIL, resp.data);
      })
      .catch(err => {
        commit(COMMUNITY_ERROR);
        commit(SET_NOTIFICATION,{ type: 'error', messages: [err.response.data.message] });
        Sentry.captureException(err);
      });
  },
  [COMMUNITY_EDIT]: ({ commit }, data) => {
    const updateData = data.formData ?data.formData :{isActive: data.isActive};
    commit(COMMUNITY_REQUEST);
    return new Promise((resolve, reject) => {
      axios.put(`${API_URL}/communities/${data.id}`, updateData)
        .then(resp => {
          commit(COMMUNITY_SUCCESS);
          commit(SET_NOTIFICATION,{ type: 'info', messages: ['コミュニティが更新されました。'] });
          resolve(resp)
        })
        .catch(err => {
          commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages || [err.response.data.message] });
          commit (COMMUNITY_ERROR);
          reject(err);
          Sentry.captureException(err);
        });
    });
  },
};

const mutations = {
  [COMMUNITY_REQUEST]: state => {
    state.status = 'loading';
  },
  [COMMUNITY_SUCCESS]: state => {
    state.status = 'success';
  },
  [COMMUNITY_ERROR]: state => {
    state.status = 'error';
  },
  [SET_COMMUNITIES]: (state, payload) => {
    state.communities = payload;
    if (payload) {
      const approved = payload.filter(item => item.status === 'active');
      state.approvedCommunityList = approved;
    }
  },
  [SET_COMMUNITY_TYPES]: (state, payload) => {
    state.types = payload;
  },
  [SET_TAGS]: (state, payload) => {
    state.tags = payload;
  },
  [SET_COMMUNITY_DETAIL]: (state, payload) => {
    state.communityDetail = payload;
  },
  [UPDATE_PICTURE]: (state, payload) => {
    state.communityDetail.media = payload;
  },
}

export default {
  state,
  getters,
  actions,
  mutations
};
